export const getExtension = (filename: string): string => {
  const index = filename.lastIndexOf('.')
  return index > -1 ? filename.substring(index + 1).toLowerCase() : ''
}
